export default __webpack_public_path__ + "static/media/zcash-zec-logo.10f8298e.svg";